/**
 * Created by Wang.Qiong on 2021/9/11.
 */
import React from "react";
import { Modal, Input, Button, Table, message, Empty } from 'antd';
import { getTransactionList, getSupplyProject } from '../../utils/api'
class qualificationPublic extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            publicList: [],
            searchButtonState: '',
            loading:false,

        }
        this.opts = {
            idno: '',
            pageIndex: 0,
            pageSize: 1000
        }

    }




    //  showRoomListsModal=(projectName,roomType,roomTypeName)=>{
    //      this.opts['projectName']=projectName;
    //      this.opts['roomType']=roomType;
    //      this.opts['roomTypeName']=roomTypeName;
    //      this.setState({
    //          visible: true,
    //      });
    //  }
    //  setOptsValue = (n,e) =>{
    //      const value = e.target?e.target.value:e;
    //      this.opts[n] =value;
    //  }
    //  getSearch=()=>{
    //      this.refs.dataList.fetch(this.opts);
    //  }
    //  setVisible = e => {
    //      this.setState({
    //          visible: true,
    //      });
    //  };
    handleCancel = e => {
        this.opts['idno'] =''
        this.setState({
            visible: false,
        });
    };
    showQualification = async () => {
        let publicList = await getSupplyProject(this.opts)
        // let publicList = await getTransactionList(this.opts)
        if (publicList.code === 0) {
            this.setState({
                publicList: publicList.data.pageContent,
            })
        } else {
            message.error(publicList.message)
        }
        this.setState({
            visible: true,
        });
    }
    setOptsValue = (n, e) => {
        const value = e.target ? e.target.value : e;
        this.opts[n] = value;
    }
    getSearch = () => {
        console.log(111);
        this.opts['pageIndex'] = 0;
        this.showQualification()
    }
    render() {
        const { visible, publicList } = this.state
        const columns = [
            {
                title: '序号',
                dataIndex: 'index',
                key: 'index',
            },
            {
                title: '项目名称',
                dataIndex: 'projectName',
                key: 'projectName',
            },
            {
                title: '房型',
                dataIndex: 'houseTypeName',
                key: 'houseTypeName',
            },
            {
                title: '可租套数',
                dataIndex: 'kezuCount',
                key: 'kezuCount',
            },
            {
                title: '登记人数',
                dataIndex: 'queueCount',
                key: 'queueCount',
            },
        ];
        return (
            <div>
                {visible?<Modal
                    title="项目供应情况展示"
                    centered
                    visible={visible}
                    onOk={this.handleCancel}
                    onCancel={this.handleCancel}
                    width={1000}
                    footer={[]}
                >
                    {/* <div className="homeModelHeader">
                        <Input placeholder="请输入身份证" style={{ margin: '0 20px 10px 5px', width: '200px' }} onBlur={this.setOptsValue.bind(this, 'idno')} />
                        <Button type="primary" htmlType="button"  onClick={(e)=>{tapOnce(this.getSearch,e,1000)}}  >
                            搜索
                        </Button>
                    </div> */}
                    <div className="homeModelBody">
                        {publicList && publicList.length > 0 ? <Table dataSource={publicList.map(this.tableModel)} columns={columns} /> : <Empty />}
                    </div>

                </Modal>:null}

            </div>
        )
    }
    tableModel = (item, index) => {
        return (
            {
                key: index,
                index: index + 1,
                projectName: item.projectName,
                houseTypeName: item.houseTypeName,
                kezuCount: item.kezuCount,
                queueCount: item.queueCount,
            }
        );
    }
    // tableModel = (item, index) => {
    //     return (
    //         <li key={index}>
    //             <span className="username">
    //                 {item.username}
    //             </span>
    //             <span className="telephone">
    //                 {item.telephone}
    //             </span>
    //         </li>
    //     );
    // }
}
export default qualificationPublic;
